import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  id: "materials"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ButtonAccordion = _resolveComponent("ButtonAccordion")!

  return (_ctx.storeLoader.load[3])
    ? (_openBlock(), _createBlock(_component_Loader, {
        key: 0,
        loader: _ctx.storeLoader.load[3],
        loaderSize: "h-28",
        spinnerSize: "small"
      }, null, 8, ["loader"]))
    : (_ctx.storeMaterial.materials?.length !== 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeMaterial.materials, (material, materialIndex) => {
            return (_openBlock(), _createElementBlock("div", { key: materialIndex }, [
              _createVNode(_component_ButtonAccordion, {
                data: material,
                index: materialIndex,
                isMaterial: ""
              }, null, 8, ["data", "index"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
}